(() => {
  'use strict';
  const bar = document.querySelector('[data-ils-sticky-cart]');
  const source = document.querySelector('#MainContent .product-section[data-modal="false"]');
  if (!bar || !source) return;
  const form = source.querySelector('.product-single__form');
  const original = form && form.querySelector('[data-add-to-cart]');
  if (!original) return;
  const product = JSON.parse(document.getElementById('IlsStickyProduct').textContent);
  const action = bar.querySelector('[data-ils-sticky-action]');
  const price = bar.querySelector('[data-ils-sticky-price]');
  const selection = bar.querySelector('[data-ils-sticky-selection]');
  const mobile = matchMedia('(max-width: 768px)');
  const sizeGroup = [...source.querySelectorAll('.variant-input-wrap')].find(el => /numara|beden|size/i.test(el.getAttribute('name') || el.dataset.handle || ''));
  let sizeChosen = !sizeGroup || new URLSearchParams(location.search).has('variant');
  let current = product.variants.find(v => String(v.id) === String(form.querySelector('[name="id"]').value));
  let passed = false;
  const money = cents => window.theme && theme.Currency ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat) : new Intl.NumberFormat('tr-TR', {style:'currency', currency:'TRY'}).format(cents / 100);
  const update = () => {
    passed = original.getBoundingClientRect().bottom <= 0;
    const modal = document.documentElement.classList.contains('js-drawer-open') || document.documentElement.classList.contains('modal-open') || document.body.classList.contains('modal-open') || document.querySelector('.pswp--open');
    const visible = mobile.matches && passed && !modal;
    bar.hidden = !visible;
    document.body.classList.toggle('ils-sticky-cart-visible', visible);
    if (current) price.innerHTML = money(current.price);
    selection.textContent = sizeChosen && current ? ((product.variants.length === 1 && current.title === 'Default Title') ? product.title : current.options.join(' / ')) : 'Numara seç';
    action.textContent = !sizeChosen ? 'Numara seç' : (original.querySelector('[data-add-to-cart-text]') || original).textContent.trim();
    action.disabled = sizeChosen && (original.disabled || !current || !current.available);
    action.setAttribute('aria-busy', original.classList.contains('btn--loading') ? 'true' : 'false');
  };
  source.addEventListener('change', e => {
    if (sizeGroup && sizeGroup.contains(e.target)) sizeChosen = true;
    // The theme updates the master variant select after its variant event.
    requestAnimationFrame(() => {
      current = product.variants.find(v => String(v.id) === String(form.querySelector('[name="id"]').value));
      update();
    });
  });
  source.addEventListener('variantChange', e => {current = e.detail.variant; requestAnimationFrame(update);});
  action.addEventListener('click', () => {
    if (!sizeChosen) {
      sizeGroup.scrollIntoView({behavior:'smooth', block:'center'});
      const input = sizeGroup.querySelector('input:not(.disabled),select');
      if (input) input.focus({preventScroll:true});
      return;
    }
    // Delegate to the existing form so quantity, selling plans, validation and cart drawer stay consistent.
    if (!action.disabled) original.click();
  });
  const observe = new IntersectionObserver(entries => {
    const rect = entries[0].boundingClientRect;
    passed = !entries[0].isIntersecting && rect.bottom <= 0;
    update();
  });
  observe.observe(original);
  let scrollPending = false;
  window.addEventListener('scroll', () => {
    if (scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(() => { scrollPending = false; update(); });
  }, {passive:true});
  new MutationObserver(update).observe(original, {attributes:true, childList:true, subtree:true});
  new MutationObserver(update).observe(document.documentElement, {attributes:true, attributeFilter:['class']});
  new MutationObserver(update).observe(document.body, {attributes:true, attributeFilter:['class']});
  mobile.addEventListener('change', update);
  update();
})();
